
import InlineDialog from '@atlaskit/inline-dialog';
import React, { Component } from 'react';

import { getRoomName, setPassword } from '../../base/conference';
import { getLocalizedDateFormatter, translate } from '../../base/i18n';
import { Icon, IconArrowDown, IconArrowUp, IconPhone, IconVolumeOff } from '../../base/icons';
import { isVideoMutedByUser } from '../../base/media';
import { ActionButton, InputField, PreMeetingScreen, ToggleButton, LeftScreen } from '../../base/premeeting';
import { connect } from '../../base/redux';
import { getDisplayName, updateSettings } from '../../base/settings';
import { getLocalJitsiVideoTrack } from '../../base/tracks';
import { isButtonEnabled } from '../../toolbox/functions.web';
import {
    joinConference as joinConferenceAction,
    joinConferenceWithoutAudio as joinConferenceWithoutAudioAction,
    setSkipPrejoin as setSkipPrejoinAction,
    setJoinByPhoneDialogVisiblity as setJoinByPhoneDialogVisiblityAction,
    updateAdminAvailability
} from '../actions';
import {
    isDeviceStatusVisible,
    isDisplayNameRequired,
    isJoinByPhoneButtonVisible,
    isJoinByPhoneDialogVisible,
    isPrejoinSkipped
} from '../functions';

import JoinByPhoneDialog from './dialogs/JoinByPhoneDialog';
import DeviceStatus from './preview/DeviceStatus';

import { SettingsButton, SETTINGS_TABS } from '../../settings';

import io from 'socket.io-client';
import { getNearestServer, onLatencyCheck } from './Latency';
import { _connect, Prejoin } from './Prejoin';

declare var config: Object;
declare var interfaceConfig: Object;

window.socket = io(window.API_DOMAIN);
let interval;

function getTimeNow() {
    return getLocalizedDateFormatter().format('h:mm A | ddd, MMM D')
}

class RPC_Prejoin extends Prejoin {
    constructor(props) {
        super(props);

        this._setPassword = this._setPassword.bind(this);
        this._reJoinWithPassword = this._reJoinWithPassword.bind(this);
        this._downloadApp = this._downloadApp.bind(this);
        this._launchApp = this._launchApp.bind(this);
        this.nameFieldRef = React.createRef();

        this.state = {
            ...super.state,
            desktop: !window.name ? false : true,
            password: '',
            passwordEnabled: false,
            permission: false,
            user_id: null,
            time: null,
            participants: [],
            iframe: null
        };

        function setRegion(nearest_server) {
            if(!nearest_server) { return; }
            const userRegion = nearest_server.substring(
                nearest_server.lastIndexOf("region-"),
                nearest_server.lastIndexOf("-meeting")
            );
            config.deploymentInfo.userRegion = userRegion;
        }
        setRegion(getNearestServer());
        onLatencyCheck((nearest_server) => {
            setRegion(nearest_server);
        });
    }

    componentWillUnmount() {
        clearInterval(interval);
    }

    componentDidMount() {
        const { roomName } = this.props;
        interval = setInterval(() => {
            this.setState({
                time: getTimeNow()
            })
            socket.emit('info', this.props.roomName);
        }, 1000);
        socket.emit('info', this.props.roomName);
        socket.on('info', (info) => {
            if (info.media_server) {
                config.deploymentInfo.userRegion = info.media_server
                config.deploymentInfo.region = info.media_server
            }
            let isAdminExist = info.members.findIndex(p => p.presenter) != -1;
            this.setState({
                participants: info.members
            });
            APP.store.dispatch(updateAdminAvailability(isAdminExist))
        });
        socket.on('open', () => {
            clearInterval(interval);
        });
        this._fetchMeeting(roomName);
    }

    async _fetchMeeting(roomName) {
        const url = new URL(window.location.href);
        const unified_token = url.searchParams.get('unified_token');
        let res;
        if(unified_token) {
            res = await fetch(window.API_DOMAIN+'/api/v1/get-meeting-by-slug?slug='+roomName+'&token='+unified_token, {
                credentials: 'include'
            })
        } else {
            res = await fetch(window.API_DOMAIN+'/api/v1/get-meeting-by-slug?slug='+roomName, {
                credentials: 'include'
            })
        }
        const data = await res.json();
        if(!data) { location.pathname = '/home/'; }
        // passwordEnabled, user_id, password, permission
        APP.store.getState()['features/base/conference'].meeting = data;
        window.lobby_password = data.password;
        this.setState({
            passwordEnabled: data.passwordEnabled,
            haveAccess: data.password ? true : false,
            password: data.password || '',
            permission: data.permission,
            user_id: data.user_id
        });
    }


    _onJoinButtonClick() {
        if (this.props.showErrorOnJoin) {
            this.setState({
                showError: true,
                errorMessage: null
            });
            this.nameFieldRef.current._focusName();
            return;
        }

        // if (this.state.passwordEnabled && !this.state.password) {
        //     this.setState({
        //         showError: true,
        //         errorMessage: "Please enter a valid password"
        //     });

        //     return;
        // }

        if (this.state.password) {
            APP.store.getState()['features/base/conference'].password = this.state.password;
        }
        if (this.state.permission) {
            APP.store.getState()['features/lobby'].lobbyEnabled = true;
        }

        this.setState({ showError: false, errorMessage: null });

        if (this.state.passwordEnabled) {
            APP.store.dispatch({type: "ASKING_PASSWORD_CHANGED"});
        }

        this.props.joinConference();
    }

    _setPassword: () => void;

    _setPassword(password) {
        window.lobby_password = password;
        this.setState({
            password: password
        })
    }

    _reJoinWithPassword: () => void;

    _reJoinWithPassword() {
        const { dispatch } = APP.store;
        const conference = APP.store.getState()['features/base/conference'].passwordRequired;
        dispatch(setPassword(
            conference,
            conference.join,
            this.state.password
        ));
    }

    _downloadApp: () => void;

	/**
     * Download Desktop Application
     *
     * @returns {undefined}
     */
	_downloadApp() {
        APP.conference.muteVideo(true);
        APP.conference.muteAudio(true);

        const {PROVIDER_NAME } = interfaceConfig;
        fetch(window.API_DOMAIN+'/api/v1/downloadToken?slug='+location.pathname.slice(6), {
            credentials: 'include'
        }).then(res => res.json()).then(token => {
            let ext="";
            let hash = "";
            if (location.hostname == "meeting.epyc.com") {
                hash = "epyc";
            }
            if(navigator.platform.slice(0,3).toLowerCase() == 'win') {
                ext = '.exe#'
            } else if(navigator.platform.slice(0,3).toLowerCase() == 'mac') {
                ext = '.pkg#'
            } else if(navigator.platform.slice(0,3).toLowerCase() == 'lin') {
                ext = '.deb#'
            }
            this.setState({ iframe: `<iframe style="display:none" src="https://meetingcdn.remotepc.com/iframe.html?${PROVIDER_NAME}Meeting-2.8.7_${token.token.split("_")[0]}${ext}${hash}" />`})
        });
    }

	_launchApp: () => void;

	/**
     * Launch Desktop Application
     *
     * @returns {undefined}
     */
	_launchApp() {
        APP.conference.muteVideo(true);
        APP.conference.muteAudio(true);

        const { PROTOCOL } = interfaceConfig;
        fetch(window.API_DOMAIN+'/api/v1/appToken', {
            credentials: 'include'
        }).then(res => res.json()).then(token => {
            let download = setTimeout(() => {
                this._downloadApp();
            }, 3000);
            window.onblur = function() {
                clearTimeout(download);
            }
            if (/MSIE 9/i.test(navigator.userAgent) || /rv:11.0/i.test(navigator.userAgent) || /MSIE 10/i.test(navigator.userAgent)) {
                clearTimeout(download);
            }
            window.location = (PROTOCOL?PROTOCOL:"remotepcmeeting") +"://"+(location.pathname.slice(6))+'/?token='+token;
        });
    }


    _joinDifferent() {
        window.parent.postMessage('join-different', '*');
    }

    _renderFooter() {
        return this.props.deviceStatusVisible && <DeviceStatus />;
    }

    render() {
        const {
            hasJoinByPhoneButton,
            joinConference,
            joinConferenceWithoutAudio,
            name,
            showAvatar,
            showCameraPreview,
            showDialog,
            showConferenceInfo,
            showJoinActions,
            t,
            videoTrack
            , error, loading, meeting, left, password_changed
        } = this.props;

        const { _closeDialog, _onDropdownClose, _onJoinButtonClick, _onOptionsClick, _setName, _setPassword, _showDialog, _reJoinWithPassword } = this;

        const { showJoinByPhoneButtons, showError, password, passwordEnabled, permission, haveAccess, time, participants, iframe, errorMessage, desktop } = this.state;
        return (
            <div className="join-page">
                <div className="join-header">
                    <div className="logo">
                        <img src={ interfaceConfig.DEFAULT_LOGO_URL } height="45"/>
                    </div>
                    <div className="time">{ time }</div>
                    <div className="rp-menu">
                        <SettingsButton
                                defaultTab = { SETTINGS_TABS.CALENDAR } />
                    </div>
                </div>
            { left && <LeftScreen></LeftScreen> }
            { !left &&
            <PreMeetingScreen
                footer = { this._renderFooter() }
                name = { name }
                showAvatar = { showAvatar }
                showConferenceInfo = { showConferenceInfo }
                // skipPrejoinButton = { this._renderSkipPrejoinButton() }
                title = { t('prejoin.joinMeeting') }
                videoMuted = { !showCameraPreview }
                videoTrack = { videoTrack }>
                {meeting.id && (
                    <div className = 'prejoin-input-area-container'>
                        <h3>{ meeting.name }</h3>
                        <span>
                            { !(!participants.length) &&
                                <>
                                    { participants.map((participant, i) => {
                                        if (i == 5) { return <b> and {participants.length - 5} others</b> }
                                        if(i > 5) { return null }
                                        return <b key={participant.id}>{ i ? ', ' : '' } {participant.user.name} { participant.presenter && <i>(Admin)</i> }</b>
                                    }) }
                                </>
                            } { (!participants.length) && <b>No one else is here</b> }
                        </span>
                        <div className = 'prejoin-input-area'>
                            { ((!window.User.id && (meeting.participant_without_host || participants.findIndex(p => p.presenter) != -1))) && <InputField
                                autoFocus = { true }
                                className = { showError ? '' : '' }
                                // hasError = { showError }
                                onChange = { _setName }
                                onSubmit = { _onJoinButtonClick }
                                placeHolder = { 'Enter Your Name' }
                                value = { name }
                                ref = { this.nameFieldRef }/> }
                            {/* { passwordEnabled && window.User.id != meeting.user_id && participants.findIndex(p => p.presenter) != -1 && <InputField
                                autoFocus = { false }
                                className = { showError ? '' : '' }
                                // hasError = { showError }
                                onChange = { _setPassword }
                                onSubmit = { _onJoinButtonClick }
                                placeHolder = { 'Meeting Password' }
                                value = { password } /> } */}

                            { showError && <div
                                className = 'prejoin-error'
                                data-testid = 'prejoin.errorMessage'>{ errorMessage || t('prejoin.errorMissingName')}</div> }

                            { error && error.name == "conference.connectionError.membersOnly" && <div
                                className = 'prejoin-error'
                                data-testid = 'prejoin.errorMessage'>{ errorMessage || t('lobby.joiningMessage')}</div> }

                            { error && !password_changed && error.name == "conference.passwordRequired" && <div
                                className = 'prejoin-error'
                                data-testid = 'prejoin.errorMessage'>Please enter a valid password</div> }

                            { error && error.name == "conference.connectionError.accessDenied" && <div
                                className = 'prejoin-error'
                                data-testid = 'prejoin.errorMessage'>Your request has been denied to join this meeting</div> }

                            <div className = 'prejoin-preview-dropdown-container'>
                                <InlineDialog
                                    content = { <div className = 'prejoin-preview-dropdown-btns'>
                                        <div
                                            className = 'prejoin-preview-dropdown-btn'
                                            data-testid = 'prejoin.joinWithoutAudio'
                                            onClick = { joinConferenceWithoutAudio }>
                                            <Icon
                                                className = 'prejoin-preview-dropdown-icon'
                                                size = { 24 }
                                                src = { IconVolumeOff } />
                                            { t('prejoin.joinWithoutAudio') }
                                        </div>
                                        {hasJoinByPhoneButton && <div
                                            className = 'prejoin-preview-dropdown-btn'
                                            onClick = { _showDialog }>
                                            <Icon
                                                className = 'prejoin-preview-dropdown-icon'
                                                data-testid = 'prejoin.joinByPhone'
                                                size = { 24 }
                                                src = { IconPhone } />
                                            { t('prejoin.joinAudioByPhone') }
                                        </div>}
                                    </div> }
                                    isOpen = { showJoinByPhoneButtons }
                                    onClose = { _onDropdownClose }>
                                    { (loading || password_changed) && <div className="loader-a"></div>}
                                    { !loading && !(error && error.name) && (window.User.id == meeting.user_id || meeting.participant_without_host || (participants.findIndex(p => p.presenter) != -1) ) && <ActionButton
                                        hasOptions = { false }
                                        onClick = { _onJoinButtonClick }
                                        testId = 'prejoin.joinMeeting'
                                        type = 'primary'>
                                        { 'Join' }
                                    </ActionButton>}
                                    { !loading && !password_changed && error && error.name == 'conference.passwordRequired' && <ActionButton
                                        hasOptions = { false }
                                        onClick = { _reJoinWithPassword }
                                        testId = 'prejoin.joinMeeting'
                                        type = 'primary'>
                                        { 'Join' }
                                    </ActionButton>}
                                </InlineDialog>
                            </div>
                        </div>
                        {/* {!desktop && <><hr /><div className="footer"><a onClick={this._launchApp}>Launch the desktop application</a> or <a onClick={this._downloadApp}>Download</a></div> */}
                        {/* <div dangerouslySetInnerHTML={{ __html: iframe ? iframe : "" }} ></div>  */}
                        {/* {desktop && <><hr /><div className="footer"><a onClick={this._joinDifferent}><b>Join Another Meeting</b></a></div>
                        <div dangerouslySetInnerHTML={{ __html: iframe ? iframe : "" }} /></> } */}
                    </div>
                )}
                { showDialog && (
                    <JoinByPhoneDialog
                        joinConferenceWithoutAudio = { joinConferenceWithoutAudio }
                        onClose = { _closeDialog } />
                )}
            </PreMeetingScreen> }
            </div>
        );
    }
}

function mapStateToProps(state, ownProps): Object {

    const { error, loading, left, password_changed } = state['features/prejoin'];
    const meeting = state['features/base/conference'].meeting || {};

    return {
        error, loading, meeting, left, password_changed
    };
}

const mapDispatchToProps = {};

export default _connect(connect(mapStateToProps, mapDispatchToProps)(translate(RPC_Prejoin)));